import { CommonModule } from '@angular/common';
import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ApiError, HttpService } from '../../../services/http.service';
import { CustomToastComponent } from '../../toast/custom-toast.component';

@Component({
  selector: 'app-media-consent-dialog',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './media-consent-dialog.component.html',
  styleUrls: ['./media-consent-dialog.component.scss'],
})
export class MediaConsentDialogComponent {
  isSubmitting = false;

  constructor(
    public dialogRef: MatDialogRef<MediaConsentDialogComponent>,
    private httpService: HttpService,
    private snackBar: MatSnackBar,
    @Inject(MAT_DIALOG_DATA) public data: { userId: string },
  ) {}

  respond(approved: boolean): void {
    if (this.isSubmitting) return;
    this.isSubmitting = true;

    this.httpService
      .put<any>(`students/${this.data.userId}/media-consent/self-respond`, {
        approved,
      })
      .subscribe({
        next: () => {
          this.dialogRef.close({ responded: true, approved });
        },
        error: (error: ApiError) => {
          this.isSubmitting = false;
          this.showErrorToast(
            error?.message ?? 'Something went wrong. Please try again.',
          );
        },
      });
  }

  close(): void {
    if (this.isSubmitting) return; 
    this.dialogRef.close({ responded: false });
  }

  private showErrorToast(message: string): void {
    this.snackBar.openFromComponent(CustomToastComponent, {
      data: { message },
      duration: 3000,
      horizontalPosition: 'right',
      verticalPosition: 'top',
      panelClass: ['no-padding-snackbar', 'error-toast'],
    });
  }
}
